import { IonAccordion, IonAccordionGroup, IonBadge, IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonMenu, IonMenuButton, IonMenuToggle, IonPage, IonRouterOutlet, IonSplitPane, IonText, IonTitle, IonToolbar, useIonAlert, useIonLoading, useIonRouter, useIonToast, useIonViewDidEnter, useIonViewDidLeave } from '@ionic/react';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Redirect, Route } from 'react-router';
import { Geolocation, Position } from '@capacitor/geolocation';
import { Capacitor } from '@capacitor/core';
import { usePwaInstallMenu } from "../pwa/usePwaInstallMenu";
import { useAppContext } from '../AppProvider';
import { useCountdownTimer } from '../components/CountdownTimer';
import Account from './Account';
import AccountUpdated from './AccountUpdated';
import Alarms from './Alarms';
import Dashboard from './Dashboard';
import Timers from './Timers';
import Contacts from './Contacts';
import Kids from './Kids';
import Location from './Location';
import Partners from './Partners';
import Pets from './Pets';
import Places from './Places';
import Routes from './Routes';
import Vehicles from './Vehicles';
import Settings from './Settings';
import TimerCreate from './TimerCreate';
import TimerEdit from './TimerEdit';
import TimerView from './TimerView';
import TimerDailyEdit from './TimerDailyEdit';
import TimerDailyView from './TimerDailyView';
import ContactCreate from './ContactCreate';
import ContactEdit from './ContactEdit';
import PetCreate from './PetCreate';
import PetEdit from './PetEdit';
import KidCreate from './KidCreate';
import KidEdit from './KidEdit';
import PartnerCreate from './PartnerCreate';
import PartnerEdit from './PartnerEdit';
import PlaceCreate from './PlaceCreate';
import PlaceEdit from './PlaceEdit';
import RouteCreate from './RouteCreate';
import RouteEdit from './RouteEdit';
import TrailCreate from './TrailCreate';
import TrailEdit from './TrailEdit';
import VehicleCreate from './VehicleCreate';
import VehicleEdit from './VehicleEdit';
import SOS from './SOS';
import PaymentComplete from './PaymentComplete';
import Plans from './Plans';
import Support from './Support';
import { alarmOutline, alertCircleOutline, atOutline, caretForwardCircleOutline, carOutline, chevronForward, downloadSharp, ellipsisVerticalOutline, gitNetworkOutline, gridOutline, helpBuoy, helpBuoyOutline, helpCircleOutline, informationCircleOutline, locateOutline, locationOutline, logOutOutline, manOutline, mapOutline, navigateOutline, optionsOutline, pawOutline, peopleOutline, personOutline } from 'ionicons/icons';

const Menu: React.FC = () => {

    const items = [
        { name: 'Me', comp: Account, route: '/account/me', icon: personOutline, color: 'secondary', access: 1, custom: false },
        { name: 'Contacts', comp: Contacts, route: '/account/contacts', icon: atOutline, access: 1, custom: false },
        { name: 'Kids', comp: Kids, route: '/account/kids', icon: peopleOutline, access: 2, custom: true },
        { name: 'Partners', comp: Partners, route: '/account/partners', icon: manOutline, access: 3, custom: true },
        { name: 'Pets', comp: Pets, route: '/account/pets', icon: pawOutline, access: 2, custom: true },
        { name: 'Places', comp: Places, route: '/account/places', icon: locationOutline, access: 1, custom: false },
        { name: 'Routes', comp: Routes, route: '/account/routes', icon: navigateOutline, access: 1, custom: false },
        { name: 'Vehicles', comp: Vehicles, route: '/account/vehicles', icon: carOutline, access: 1, custom: true },
    ];

    //const [isMenuVisible, setIsMenuVisible] = useState<boolean>(false);  
    //const [secondsLeft, setSecondsLeft] = useState<number>(-1);
    const [badgeColor, setBadgeColor] = useState<string>('medium');  
    
    const platform = Capacitor.getPlatform();
    const router = useIonRouter();
    const [present, dismiss] = useIonLoading();
    const [showAlert] = useIonAlert();
    const [showToast] = useIonToast();  
    
    const { startCountdown, subscribe } = useCountdownTimer();

    const { isInstallAvailable, runInstall } = usePwaInstallMenu();

    const { authKey, authorizedMember, setShowLoader, setLoading, level, setLevel, limits, profiles, settings, setAuthKey, setActivePartners, setAuthorizedMember, setAvailableContacts, setAvailableKids, setAvailablePets, setCheckedContacts, setContacts, setKids, setPendingPartners, setPets, setPlaces, setRoutes, setSelectedVehiclesEnd, setSelectedVehiclesEnroute, setSelectedVehiclesStart, setSettings, setStartPlaces, setUserTimezone, setVehicles, setVehiclesAll, setVehiclesEnd, setVehiclesEnroute, setVehiclesStart, locationPerm, setLocationPerm, locationPermStr, setLocationPermStr, pushPermStr, setPushPermStr, currentTimer, setCurrentTimer, currentTimerEnd, setCurrentTimerEnd, currentTimerStatus, setCurrentTimerStatus, currentTimers, setCurrentTimers, setPendingTimer, Preferences, clearAllCookies } = useAppContext();

    
    //
    // Start the Countdown for Current Timer Only
    //
    useEffect(() => {
        if (currentTimerEnd > 0) startCountdown(currentTimerEnd);
    }, [currentTimer, currentTimerEnd]);

    
    //
    // Get all current Timers
    //
    useEffect(() => {
        const getCurrentAndPendingTimers = async () => {
            const ct = await getCurrentTimers(authorizedMember.memberToken);
            /*if (!ct) {
                const pt = await getPendingTimer(authorizedMember.memberToken);
            }*/
        };

        if (authorizedMember.memberToken) {
            getCurrentAndPendingTimers();
        }
    }, [authorizedMember]); //, profiles.timers
    

    const getCurrentTimers = async (mt: any) => {
        try {
            const formData = new FormData();
            formData.append('mt', mt);
            formData.append('timers', 'all-current');
            const response = await fetch('https://api.besolowise.com/timers/get/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });

            if(response.ok) {                   
                const obj = await response.json();
                //console.log(obj);

                setCurrentTimers(obj);
                if (obj.length >= 1) {
                    setCurrentTimer(obj[0]);
                    setCurrentTimerEnd(obj[0].endTimeUNIX);
                    setCurrentTimerStatus(obj[0].status);
                    //console.log(obj[0]);
                    return true;
                } else return false;
            } else {
                showToast({
                    message: 'Response Error.',
                    duration: 2000,
                    color: 'danger',
                    position: 'bottom'
                });
                return false;
            }
        } catch(error) {
            showToast({
                message: 'No Connection',
                duration: 1000,
                color: 'danger',
                position: 'bottom'
            });
            return false;
        } 
    };


    const getPendingTimer = async (mt: any) => {
        try {
            const formData = new FormData();
            formData.append('mt', mt);
            formData.append('timers', 'pending');
            const response = await fetch('https://api.besolowise.com/timers/get/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });

            if(response.ok) {                   
                const obj = await response.json();
                setPendingTimer(obj[0]);
            } else {
                showToast({
                    message: 'Response Error.',
                    duration: 2000,
                    color: 'danger',
                    position: 'bottom'
                });
            }
        } catch(error) {
            showToast({
                message: 'No Connection',
                duration: 1000,
                color: 'danger',
                position: 'bottom'
            });
        } 
    };

    
    useEffect(() => {
        if (currentTimerStatus) {
            if(currentTimerStatus == '1') setBadgeColor('secondary');
            else if(currentTimerStatus == '2') setBadgeColor('success');
            else if(currentTimerStatus == '3') setBadgeColor('warning');
            else if(currentTimerStatus == '4') setBadgeColor('danger');
            else setBadgeColor('success');
        }
    }, [currentTimerStatus]);


    //
    // Get Location Permissions
    //
    const getLocationPerms = async () => {
        const locPermObj = await Geolocation.checkPermissions();
        let permRequest: boolean | Position = false;
        let locPermStr = '';
        if (locPermObj) {
            locPermStr = locPermObj.location;
            locPermStr = locPermStr.charAt(0).toUpperCase() + locPermStr.slice(1);
            
            if (locPermStr !== 'Granted') permRequest = await requestLocPerms();
            else permRequest = true;
        }
        
        if (permRequest) locPermStr = 'Granted';
        setLocationPerm(permRequest); 
        setLocationPermStr(locPermStr);       
    };


    //
    // Request Location Permissions
    //
    const requestLocPerms = async () => {        
        if (platform === 'web') {
            try {
                var CurrentPosition = await Geolocation.getCurrentPosition();                
                return true;
            } catch (error) {
                return false;
            }
        } else {
            var req = await Geolocation.requestPermissions({permissions: ['location']});
            
            if (req.location === 'granted') {
                return true;
            } 
            else return false;
            
        }
    };


    // 
    // Push Notification functions -- Start
    //
    const requestPushPerms = async () => {
        if (!('Notification' in window)) {
            console.warn('Notifications API not supported in this browser.');
            return;
        }
        const result = await Notification.requestPermission();
        setPushPermStr(result);
    };
    

    // 
    // Handle the event when the menu visibility changes
    //
    const handleMenuVisibilityChange = (event: CustomEvent) => {
        let element = document.getElementById('main');
        if (element !== null) element.removeAttribute('aria-hidden');
    };
    

    //
    // Member Log-Out
    //
    const memberLogOut = async () => {
        showAlert({
            header: 'Please confirm:',
            message: 'Are you sure you want to log out?',
            buttons: [
                { 
                    text: 'Cancel', 
                    role: 'cancel', 
                    cssClass: 'alert-button-cancel',
                },
                {
                    text: 'Log-Out',
                    role: 'confirm',
                    cssClass: 'alert-button-confirm',
                    handler: async () => {
                        setShowLoader(true);
                        await present('Logging out...');
                        try {
                            const formData = new FormData();
                            formData.append('mt', authKey.mt);
                            const response = await fetch('https://api.besolowise.com/members/authenticate/signout/', {
                                method: 'POST',
                                credentials: 'include',
                                body: formData
                            });
                            if(response.ok) {
                                setLoading(true);
                                //const obj = await response.json();
                                await Preferences.remove({key: 'solowise'});   
                                //await clearAllCookies(); // Now done server-side
                                setAuthKey({});
                                setActivePartners({});
                                setAuthorizedMember({});
                                setCurrentTimer({});
                                setCurrentTimerEnd(null);
                                setCurrentTimerStatus('');
                                setCurrentTimers({});
                                setAvailableContacts({});
                                setAvailableKids({});
                                setAvailablePets({});
                                setCheckedContacts({});
                                setContacts({});
                                setKids({});
                                setLevel({});
                                setPendingPartners({});
                                setPets({});
                                setPlaces({});
                                setRoutes({});
                                setSelectedVehiclesEnd({});
                                setSelectedVehiclesEnroute({});
                                setSelectedVehiclesStart({});
                                setSettings({});
                                setStartPlaces({});
                                setUserTimezone({});
                                setVehicles({});
                                setVehiclesAll({});
                                setVehiclesEnd({});
                                setVehiclesEnroute({});
                                setVehiclesStart({});
                                setTimeout(async () => {
                                    dismiss();
                                    //if (platform === 'web') window.location.href = '/';
                                    //else router.push('/', 'forward');
                                    router.push('/', 'forward');
                                }, 2000);                                
                            } else {
                                dismiss();
                                showToast({
                                    message: 'Log-out Error',
                                    duration: 2000,
                                    color: 'warning',
                                    position: 'middle'
                                });
                            }
                        } catch(error) {
                            dismiss();
                            showToast({
                                message: 'Log-out Error: ' + error,
                                duration: 2000,
                                color: 'warning',
                                position: 'middle'
                            });
                        } 
                    }
                }
            ]
        })
    };    

    
    useIonViewDidEnter(() => {
        document.querySelectorAll('[aria-hidden]').forEach(element => {
            //console.log(element);
            element.removeAttribute('aria-hidden');
        });
        const didEnter = async () => {
            await getLocationPerms();   
            await requestPushPerms();    
        };  
        didEnter();                              
    });


    return (
        <IonPage>
            <IonSplitPane contentId='main' when='lg'>
                <IonMenu contentId='main' side="end" onIonWillClose={handleMenuVisibilityChange} onIonWillOpen={handleMenuVisibilityChange}>
                    <IonHeader>
                        <IonToolbar color={'light'}>
                            <IonMenuToggle slot='end'>
                                <IonButton fill='clear'><IonIcon color={'tertiary'} icon={chevronForward} size='large'></IonIcon></IonButton>
                            </IonMenuToggle>
                            <IonTitle color={'tertiary'}>My Account</IonTitle>
                        </IonToolbar>
                    </IonHeader>
                    <IonContent className="ion-padding">
                        {/*<div>
                            {secondsLeft === null
                                ? "No active timer"
                                : `Timer: ${secondsLeft}s left`}
                        </div>*/}
                        <IonList inset>
                            <IonMenuToggle key={'90'} autoHide={false}>
                                <IonItem routerLink={'/account/sos'} routerDirection='forward'>
                                    <IonIcon slot='start' color={'danger'} icon={alertCircleOutline} /> 
                                    <IonText color={'danger'}><strong>EMERGENCY</strong></IonText>
                                </IonItem>
                            </IonMenuToggle>

                            <IonMenuToggle key={'91'} autoHide={false}>
                                <IonItem routerLink={'/account/dashboard'} routerDirection='forward'>
                                    <IonIcon slot='start' color={'secondary'} icon={gridOutline} /> 
                                    <IonText><strong>Dashboard</strong></IonText>
                                </IonItem>
                            </IonMenuToggle>

                            {locationPerm &&
                                (
                                  <IonMenuToggle key={'93'} autoHide={false}>
                                    <IonItem routerLink={'/account/location'} routerDirection='forward'>
                                        <IonIcon slot='start' color={'secondary'} icon={mapOutline} /> 
                                        <IonText><strong>Map</strong></IonText>
                                    </IonItem>
                                  </IonMenuToggle>
                                )
                            }
                            
                            {(currentTimer.token && currentTimer.startTime != '') &&
                            <IonMenuToggle key={'94'} autoHide={false}>
                                <IonItem routerLink={`/account/timer/view/${currentTimer.token}`} routerDirection='forward'>
                                    <IonIcon slot='start' color={'secondary'} icon={caretForwardCircleOutline} /> 
                                    <IonText><strong><em>Next Check-in</em></strong></IonText>
                                </IonItem>
                            </IonMenuToggle>
                            }

                            {(currentTimer.token && currentTimer.startTime == '') &&
                            <IonMenuToggle key={'94'} autoHide={false}>
                                <IonItem routerLink={`/account/timer/view-daily/${currentTimer.token}`} routerDirection='forward'>
                                    <IonIcon slot='start' color={'secondary'} icon={caretForwardCircleOutline} /> 
                                    <IonText><strong><em>Next Check-in</em></strong></IonText>    
                                </IonItem>
                            </IonMenuToggle>
                            }

                            <IonMenuToggle key={'92'} autoHide={false}>
                                <IonItem routerLink={'/account/timers'} routerDirection='forward'>
                                    <IonIcon slot='start' color={'secondary'} icon={alarmOutline} /> 
                                    <IonText><strong>Timers</strong></IonText> 
                                </IonItem>
                            </IonMenuToggle>

                            <IonAccordionGroup expand="inset" className="menu-accordion">
                                <IonAccordion value="profiles" toggleIconSlot="end" color={'secondary'}>
                                    <IonItem slot="header">
                                        <IonIcon slot='start' color={'tertiary'} icon={ellipsisVerticalOutline} /> 
                                        <IonLabel color={'tertiary'}>Profiles</IonLabel>
                                    </IonItem>
                                    <div slot="content">
                                        <IonList> 
                                            {level !== null &&   
                                                items.map((item, index) => (
                                                ((item.custom === false || settings[`menu${item.name}`] === '1')) && level.memberLevelID >= item.access &&
                                                    <IonMenuToggle key={index} autoHide={false}>
                                                        <IonItem routerLink={item.route} routerDirection='forward'>
                                                            <IonIcon slot='start' color={'tertiary'} icon={item.icon} />
                                                            { item.name != 'Me' && 'My ' } {item.name}
                                                        </IonItem>
                                                    </IonMenuToggle>
                                                    )  
                                                )                                            
                                            }
                                        </IonList> 
                                    </div> 
                                </IonAccordion>
                            </IonAccordionGroup>                            

                            <IonMenuToggle key={'95'} autoHide={false}>
                                <IonItem routerLink={'/account/preferences'} routerDirection='forward'>
                                    <IonIcon color={'secondary'} slot='start' icon={optionsOutline} /> Settings
                                </IonItem>
                            </IonMenuToggle>

                            {isInstallAvailable &&
                            <IonItem className='cursor-pointer' lines='none' 
                                onClick={async () => {
                                    await runInstall();
                                }}>
                                <IonIcon color={'secondary'} slot='start' icon={downloadSharp} /> Install SoloWise
                            </IonItem>
                            }

                            <IonMenuToggle key={'96'} autoHide={false}>
                                <IonItem routerLink={'/account/support'} routerDirection='forward'>
                                    <IonIcon color={'tertiary'} slot='start' icon={helpBuoy} /> Support
                                </IonItem>
                            </IonMenuToggle>
                            <IonMenuToggle key={'98'} autoHide={false}>
                                <IonItem routerLink={'/faq'} routerDirection='forward'>
                                    <IonIcon color={'tertiary'} slot='start' icon={helpCircleOutline} /> FAQ
                                </IonItem>
                            </IonMenuToggle>
                            <IonMenuToggle key={'99'} autoHide={false}>
                                <IonItem className='cursor-pointer' onClick={memberLogOut}>
                                    <IonIcon color={'tertiary'} slot='start' icon={logOutOutline} /> Log-Out
                                </IonItem>
                            </IonMenuToggle>

                        </IonList>
                    </IonContent>
                </IonMenu>
                
                <IonRouterOutlet id='main'>
                    
                    <Route path={'/account/sos'} component={SOS} exact />
                    <Route path={'/account/dashboard'} component={Dashboard} exact />
                    
                    <Route path={'/account/location'} component={Location} exact />
                    <Route path={'/account/payment/complete'} component={PaymentComplete} exact />
                    <Route path={'/account/updated'} component={AccountUpdated} exact />
                    <Route path={'/account/plans'} component={Plans} exact />
                    <Route path={'/account/preferences'} component={Settings} exact />
                    <Route path={'/account/support'} component={Support} exact />

                    <Route path={'/account/alarms'} component={Alarms} exact /> 
                    
                    <Route path={'/account/timers'} component={Timers} exact /> 
                    <Route path={'/account/timer/create'} component={TimerCreate} exact /> 
                    <Route path={'/account/timer/edit/:token'} component={TimerEdit} exact />
                    <Route path={'/account/timer/view/:token'} component={TimerView} exact />
                    <Route path={'/account/timer/edit-daily/:token'} component={TimerDailyEdit} exact />
                    <Route path={'/account/timer/view-daily/:token'} component={TimerDailyView} exact />

                    <Route path={'/account/contact/create'} component={ContactCreate} exact /> 
                    <Route path={'/account/contact/edit/:token'} component={ContactEdit} exact />  

                    <Route path={'/account/pet/create'} component={PetCreate} exact /> 
                    <Route path={'/account/pet/edit/:token'} component={PetEdit} exact />

                    <Route path={'/account/kid/create'} component={KidCreate} exact /> 
                    <Route path={'/account/kid/edit/:token'} component={KidEdit} exact />

                    <Route path={'/account/partner/create'} component={PartnerCreate} exact /> 
                    <Route path={'/account/partner/edit/:token'} component={PartnerEdit} exact />

                    <Route path={'/account/place/create'} component={PlaceCreate} exact /> 
                    <Route path={'/account/place/edit/:token'} component={PlaceEdit} exact /> 

                    <Route path={'/account/route/create'} component={RouteCreate} exact /> 
                    <Route path={'/account/route/edit/:token'} component={RouteEdit} exact /> 

                    <Route path={'/account/trail/create'} component={TrailCreate} exact /> 
                    <Route path={'/account/trail/edit/:token'} component={TrailEdit} exact /> 

                    <Route path={'/account/vehicle/create'} component={VehicleCreate} exact /> 
                    <Route path={'/account/vehicle/edit/:token'} component={VehicleEdit} exact />

                    {items.map((item, index) => (
                        <Route key={index} path={item.route} component={item.comp} exact />
                    ))} 

                    <Route path={'/account'} exact>
                        <Redirect to='/account/dashboard' />
                    </Route>                  
                    
                </IonRouterOutlet>
                
            </IonSplitPane>
        </IonPage>
    );
};

export default Menu;